import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../config/authAxios"



const initialState = { status: null, message: "", loading: false, data: [], error: "" }


export const saveLocationAction = createAsyncThunk(
    'save-locaton',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.patch(`/save-location`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const saveLocationSlice = createSlice({
    name: 'save-location',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(saveLocationAction.pending, (state) => {
                state.data = []
                state.loading = true
            })
            builder.addCase(saveLocationAction.fulfilled, (state, action) => {
                state.data = action.payload.data
                state.loading = false
                state.message = action.payload.message
                state.status = action.payload.status
            })
            builder.addCase(saveLocationAction.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload.error
                state.message = action.payload.message
                state.status = action.payload.status
            })
        },

})



export const saveLocationReducer = saveLocationSlice.reducer